<template>
    <div class="h-100">
        <div id="map" ref="map"></div>
    </div>
</template>

<script>
import GoogleMaps from '@/utilities/google-maps';
export default {
    props:{
        address:String,
        initialPos:Object,
        selectable:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return{
            map: null
        }
    },
    watch:{
        address(){
            this.setAddress()  
        }
    },
    methods:{
        setAddress(bool){
            if(this.address != ",,"){
                if(bool && this.initialPos){
                    this.map?.setCenterLatLng(this.initialPos.lat,this.initialPos.lng)
                }else {
                    this.map?.setCenter(this.address)
                }
            }else { this.map?.reset() }   
        }
    },
    mounted(){
        const google = new GoogleMaps()
        google.RenderMapForFindLocation(this.$refs.map,(pos)=>{
            this.$emit('location',pos)
        },this.initialPos,this.selectable).then(m=> {
            this.map = m
            this.setAddress(true)
        })
    }
}
</script>

<style>
    #map {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
</style>